export default __webpack_public_path__ + "static/media/icon.fd4f270e.svg";